import { ItemPair } from "../../firestore/Types/UI/ItemPair";

export function Combo({ label, name, items, defaultValue = "", placeholder = "", isReadonly = false, onUserChange }: { label: string, name: string, items: ItemPair[], placeholder?: string, defaultValue?: string, isReadonly?: boolean, onUserChange?: (value: string) => void }) {

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (onUserChange) {
            onUserChange(event.target.value);
        }
    }

    return (
        <div className="grid grid-cols-1 grow mb-4">
            <label className="basic-form-label">
                <span>  {label}</span>
            </label>
            <select defaultValue={defaultValue} className="basic-form-box" name={name} onChange={handleChange}>
                {items.map((item, index) => (
                    <option value={item.Value} key={index}>
                        {item.Text}
                    </option>))
                }
            </select>
            
        </div>
    );
}